import { DateTime } from "luxon";

export function formatRelativeUpdateTime(value: string | null | undefined): string | null {
  if (!value) return null;

  let dateTime: DateTime | null = null;

  try {
    dateTime = DateTime.fromISO(value, { setZone: true });
    if (!dateTime.isValid) {
      const jsDate = new Date(value);
      dateTime = Number.isNaN(jsDate.getTime()) ? null : DateTime.fromJSDate(jsDate);
    }
  } catch {
    return null;
  }

  if (!dateTime || !dateTime.isValid) {
    return null;
  }

  const now = DateTime.now();
  const diffMinutes = Math.floor(now.diff(dateTime, "minutes").minutes);

  // If less than 1 minute ago, show "Updated now"
  if (diffMinutes < 1) {
    return "Updated just now";
  }

  // Use toRelative with minute precision for other cases
  const relativeTime = dateTime.toRelative({
    unit: ["years", "months", "weeks", "days", "hours", "minutes"],
  });

  return relativeTime ? `Updated ${relativeTime}` : null;
}
